<template>
  <div class="test-container">
    <!-- 操作 -->
    <div style="overflow:hidden">
      <div>
        <span class="title">角色管理列表</span>
        <div style="display:inline-block;float:right">
          <el-button type="primary" @click="add">新建角色</el-button>
        </div>

      </div>
    </div>
    <!-- 表格 -->
    <el-table
      :key="tableKey"
      ref="multipleTable"
      v-loading="listLoading"
      stripe
      :data="list"
      tooltip-effect="dark"
      style="width: 100%"
      @cell-mouse-enter="operateShow"
      @cell-mouse-leave="operateClose"
    >
      <el-table-column :show-overflow-tooltip="true" fixed label="角色编号" min-width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.sortNum }}</span>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="角色key" min-width="100px">
        <template slot-scope="scope">{{ emptyDeal(scope.row.roleKey) }}</template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="角色名称" min-width="100px">
        <template slot-scope="scope">{{ emptyDeal(scope.row.name) }}</template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="所属应用" min-width="100px">
        <template slot-scope="scope">{{ systemStatus(scope.row.appId).val }}</template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="角色类型" min-width="100px">
        <template slot-scope="scope">{{ roleStatus(scope.row.roleType).val }}</template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="角色描述" min-width="100px">
        <template slot-scope="scope">{{ emptyDeal(scope.row.description) }}</template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="角色功能信息" min-width="100px">
        <template slot-scope="scope">
          <span class="info">{{ emptyDeal(scope.row.description) }}</span>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" width="150px">
        <template slot-scope="scope" class="icon">
          <div class="icon">
            <i class="el-icon-change" @click="editRole(scope.row.id)" />
            <i class="el-icon-dele" @click="delet(scope.row.id)" />
            <i class="iconfont" @click=" authorization(scope.row.appId,scope.row.id)" style="margin-left:16px">&#xe653;</i>
          </div>

        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="mt10">
      <el-pagination
        :current-page="pageInfo.currentPage"
        :page-sizes="pageInfo.pageSizeList"
        :page-size="pageInfo.limit"
        layout="total, prev, pager, next, jumper"
        :total="pageInfo.allCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 角色功能信息-->
    <div v-if="dialogVisibleInfo">
      <el-dialog
        title="角色功能信息"
        :close-on-click-modal="false"
        :visible.sync="dialogVisibleInfo"
>
        <FunctionInfo :key="new Date().getTime()" @returnResult="receiveData" />
      </el-dialog>
    </div>
    <!-- 角色授权 -->
    <template>
      <div v-if="dialogVisibleRole">
          <RoleAuthorization
          :key="new Date().getTime()"
          :app-id="appIds"
          :role-id="roleId"
          @returnResult="receiveData"
        />
      </div>
    </template>
    <!-- 添加角色 -->
    <template>
      <div v-if="dialogAddRole">
          <AddRole :key="new Date().getTime()" :role-id="id" :click-type="type" @returnResult="receiveData" />
      </div>
    </template>
  </div>
</template>
<script>
import { roleList, deleteRole, systemDetail, getSystem } from '@/api/system'
import FunctionInfo from '../FunctionInfo'
import RoleAuthorization from '../RoleAuthorization'
import AddRole from '../AddRole'
import { statusTrans, emptyTrans, sortDataList, nameTrans } from '@/api/dataTrans.js'
export default {
  components: {
    FunctionInfo,
    RoleAuthorization,
    AddRole
  },
  data() {
    return {
      list: [],
      listLoading: false,
      tableKey: 0,
      pageInfo: {
        limit: 10,
        allCount: 0,
        currentPage: 1,
        currentPageCount: 0,
        showEdit: false // 是否显示快捷编辑代码框
      },
      dialogVisibleInfo: false,
      businessList: [],
      flag: false,
      type: 0,
      title: '添加角色',
      parmas: null,
      dialogVisibleRole: false,
      dialogAddRole: false,
      id: null,
      appIds: null,
      roleId: null,
      nameList: [],
      systemList: [],
      roleList: [{ id: 1, name: '系统' }, { id: 2, name: '普通' }]
    }
  },
  mounted() {
    this.getSystemList()
    this.getRoleList()
    // this.getSystemName()
  },

  methods: {
    getSystemList() {
      getSystem({
        pageNo: 1,
        pageSize: 1000
      }).then(res => {
        if (res && res.code == 0) {
          this.systemList = res.data.items
        }
      })
    },
    getRoleList() {
      roleList({
        pageNo: this.pageInfo.currentPage,
        pageSize: this.pageInfo.limit
      }).then(res => {
        if (res && res.code == 0) {
          // for (var i = 0; i < this.nameList.length; i++) {
          //   for (var j = 0; j < res.data.items.length; j++) {
          //     if (this.nameList[i].appId == res.data.items[j].appId) {
          //       res.data.items[j].sysName = this.nameList[i].sysName
          //     }
          //   }
          // }

          this.list = sortDataList(res.data.items, this.pageInfo.currentPage)
          this.pageInfo.allCount = res.data.total
        }
      })
    },
    // 获取应用
    getApp(data) {
      systemDetail({
        id: data
      }).then(res => {
        if (res && res.code == 0) {
          this.list.appName = res.data.name
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.limit = val
      this.pageInfo.currentPage = 1
      this.getRoleList()
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val
      this.getRoleList()
    },
    add() {
      this.type = 0
      this.title = '添加角色'
      this.dialogAddRole = true
    },
    editRole(data) {
      this.type = 1
      this.title = '编辑角色'
      this.id = data
      this.dialogAddRole = true
    },
    delet(data) {
      this.$confirm('您确认删除吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        deleteRole({
          ids: data
        }).then(res => {
          this.$message.success('删除成功')
          this.getRoleList()
        })
      }).catch(() => { })
    },
    authorization(app, role) {
      this.appIds = app
      this.roleId = role
      this.dialogVisibleRole = true
    },
    emptyDeal(_val) {
      return emptyTrans(_val)
    },
    // 业务类型
    systemStatus(_val) {
      return nameTrans(_val, this.systemList)
    },
    // 角色类型
    roleStatus(_val) {
      return nameTrans(_val, this.roleList)
    },
    // 显示操作按钮
    operateShow(row, column, cell, event) {
      event.path[1].cells[7].children[0].children[0].style.display = 'block'
    },
    operateClose() {
      event.path[1].cells[7].children[0].children[0].style.display = 'none'
    },
    receiveData() {
      this.dialogAddRole = false
      this.dialogVisibleRole = false
      this.getRoleList()
    },
    check() {
      this.dialogVisibleInfo = true
    },
    auth() {
      this.dialogVisibleRole = true
    }
  }
}
</script>
<style lang="scss" scoped>
.operate {
  float: right;
  height: 24px;
}
[class^="el-icon-"] {
  margin-left: 18px;
  font-size: 20px;
}
.title {
  text-align: left;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
}
.el-button--primary {
  float: right;
}
.el-table {
  margin-top: 16px;
}
body .app-wrapper-new-style .test-container {
  padding: 16px 24px 100px 24px;
}
[class^="el-icon-"] {
  font-size: 16px;
  // margin-left: 24px;
}
[class^="el-icon-"]:hover {
  color: #FFA940;
}
.mt10 {
  margin-top: 24px !important;
  float: right;
}
.icon{
  display: none;
}
.set{
 margin-right:24px;
 font-size:14px;
 color:#FFA940;
 line-height: 30px;
}
.el-button{
  font-size:14px;
}
.info{
  color:#FFA940;
}
.iconfont {
    top: -2px;
    position: relative;
    font-size: 16px;
  }
</style>
